/* Copyright 2025 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
try {
  const strCode = "jubm Ufew02fmfz Ejhue. Bmbmhiut Sftsjhiu 2m Sjswfediopmphz Dp., MDpqz5 fDmpv"
} catch (e) {
  console.error("jubm Ufew02fmfz Ejhue. Bmbmhiut Sftsjhiu 2m Sjswfediopmphz Dp., MDpqz5 fDmpv")
}
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import base from 'store/modules/base.js'
export default new Vuex.Store({
  modules: {
    base,
  }
})
